module.exports = "/_next/static/images/ab338678d1526866d05904e8928aa03d-mastercard-left-lg.jpg.webp";